import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import useOrderHelper from "@/shared/v2/hooks/useOrderHelper";
import { useTranslation } from "react-i18next";
import { formatDate, getFullStreetV2 } from "@/shared/utils/helpers";

const OrderAddress = ({
  order,
  courier,
}: {
  order: OrderV2;
  courier?: string;
}) => {
  const { t } = useTranslation();
  const {
    address_geo_coordinates,
    distance_to_branch_in_km,
    assigned_courier_id_time_stamp,
    city,
  } = useOrderHelper(order);

  const address = getFullStreetV2(order) + (city ? `, ${city}` : "") || "";
  const compassHeading = address_geo_coordinates?.["5"];

  return (
    <div className="text-[1.4rem] font-semibold">
      {address.trim() && address}
      {parseFloat(distance_to_branch_in_km ?? "0") !== 0 && (
        <span className="tracking-[0.5px]" style={{ fontWeight: "bold" }}>
          {` (${distance_to_branch_in_km}Km`}
          {compassHeading && ` ${t(`compassHeading.${compassHeading}`)}`}
          {")"}
        </span>
      )}
      {courier && (
        <span
          className="text-primary tracking-[0.5px]"
          style={{ fontWeight: "semibold" }}
        >
          {address.trim() && " -"}
          {` ${courier} (${formatDate(
            assigned_courier_id_time_stamp,
            "time"
          )})`}
        </span>
      )}
    </div>
  );
};

export default OrderAddress;
